import { LocationGroup } from 'app/model/cris/location-group';

import { RestfulApiService } from './restful-api.service';

class LocationGroupService extends RestfulApiService<LocationGroup> {
    public deploy(entity: LocationGroup) {
        return this.http.post<string[]>(`${this.getAlterUrl(entity)}/deploy`);
    }

    protected getFormName(): string {
        return 'location_group';
    }

    protected getPath(): string {
        return 'location-groups';
    }
}

export const locationGroupService = new LocationGroupService();
